import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';

class FormPreviewButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        move: PropTypes.bool,
        sendFunc: PropTypes.func.isRequired
    };

    static defaultProps = {
        move: false
    };

    render() {
        const { sendFunc, classes, move } = this.props;

        return (
            <div className={move ? classes.secondPosition : classes.firstPosition}>
                <Tooltip title={Translator.translate('general.preview')} placement="top">
                    <Fab aria-label={Translator.translate('general.preview')} className={classes.btnPreview} size="small" onClick={sendFunc}>
                        <Visibility className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 50,
        right: 100,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 80
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 70
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 50
        }
    },
    secondPosition: {
        position: 'absolute',
        top: 50,
        right: 150
    },
    btnPreview: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30
        }
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormPreviewButton);



// WEBPACK FOOTER //
// ./data/components/FormPreviewButton.js